import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DiscoverBlock = makeShortcode("DiscoverBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "go-live"
    }}>{`Go live`}</h2>
    <p>{`In this section, you can learn about the steps for taking your integration into production and letting your users know about it.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/creative-cloud-libraries/docs/go-live/review-process/"
      }}>{`Submission and review`}</a></p>
    <p>{`Learn about our review process and associated timelines. Use our submission checklist to get your integration ready for review and approval by Adobe.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/creative-cloud-libraries/docs/go-live/marketing/"
      }}>{`Marketing your integration`}</a></p>
    <p>{`Ready to get the word out about your integration? Get go-to-market tips and guidelines from the Adobe Creative Cloud Developer Brand Guide.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      